import { render, staticRenderFns } from "./industryType.vue?vue&type=template&id=c44d23ee&scoped=true"
import script from "./industryType.vue?vue&type=script&lang=js"
export * from "./industryType.vue?vue&type=script&lang=js"
import style0 from "./industryType.vue?vue&type=style&index=0&id=c44d23ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44d23ee",
  null
  
)

export default component.exports